<template>
  <div class="d-flex flex-nowrap">
    <div
      v-if="hasPrependSlot"
      :style="{ 'z-index': researchers.length + 1 }"
    >
      <slot name="prepend"></slot>
    </div>
    <div
      v-for="(researcher, i) in researchersToShow"
      :key="researcher.id"
      :style="{ 'z-index': researchers.length - i }"
      :class="{ [nudgeLeft]: i > 0 || hasPrependSlot }"
    >
      <researcher-avatar
        :researcher="researcher"
        :class="{ [nudgeLeft]: i > 0 }"
        :small="small"
        :disable-popover="disablePopover"
      />
    </div>
    <researcher-avatar-overflow
      v-if="hasOverflow"
      :researchers="researchersToOverflow"
      :small="small"
      :class="nudgeLeft"
    />
  </div>
</template>

<script>
import ResearcherAvatar from './ResearcherAvatar';
import ResearcherAvatarOverflow from './ResearcherAvatarOverflow';
import { Researcher } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'ResearcherAvatarCluster',
  components: { ResearcherAvatar, ResearcherAvatarOverflow },
  props: {
    researchers: {
      type: Array,
      required: true,
      validator: (field) =>
        typeHelpers.isArrayOfType(field, Researcher),
    },
    currentResearcher: {
      type: Researcher,
      default: null,
    },
    small: {
      type: Boolean,
      default: true,
    },
    disablePopover: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  computed: {
    hasPrependSlot() {
      return !!this.$slots.prepend;
    },
    sortedResearchers() {
      const youIndex = this.researchers.findIndex(
        (r) => r.id === this.currentResearcher?.id
      );
      if (youIndex === -1) {
        return this.researchers;
      }
      const you = this.researchers[youIndex];
      const others = this.researchers.filter(
        (r) => r.id !== this.currentResearcher?.id
      );
      return [you, ...others];
    },
    researchersToShow() {
      return this.max === null
        ? this.sortedResearchers
        : this.sortedResearchers.slice(0, this.max);
    },
    hasOverflow() {
      return (
        this.max !== null && this.sortedResearchers.length > this.max
      );
    },
    researchersToOverflow() {
      return this.max !== null
        ? this.sortedResearchers.slice(this.max)
        : [];
    },
    nudgeLeft() {
      return this.small ? 'ml-n1' : 'ml-n3';
    },
  },
};
</script>
